// Datenschutzerklärung für lagerpro.app, die Desktop- und die Handy-App.
// Stand muss zu DATENSCHUTZ_VERSION im Backend (plans.js) passen — wer sich
// registriert, stimmt genau diesem Stand zu.
import RechtsRahmen from '../komponenten/RechtsRahmen';

export default function Datenschutz() {
  return (
    <RechtsRahmen titel="Datenschutzerklärung" stand="1. November 2026">
      <h2>1. Verantwortlicher</h2>
      <p>
        Quantory Solutions GmbH, Hüttenstraße 71, 40215 Düsseldorf, Deutschland ·
        E-Mail: <a href="mailto:info@quantory.de">info@quantory.de</a> · Telefon: 01777 317755.
        Weitere Angaben im <a href="/impressum">Impressum</a>.
      </p>

      <h2>2. Zwei Rollen: Ihr Konto und die Daten in Ihrem Betrieb</h2>
      <p>
        Für die Daten Ihres Kontos (Firma, Anschrift, Ansprechpartner, Zugangsdaten, Vertrag,
        Abrechnung) sind wir Verantwortlicher im Sinne der DSGVO.
      </p>
      <p>
        Die Daten, die Sie in LagerPro für Ihren Betrieb verwalten — etwa Ihre Kunden, Lieferanten,
        Rechnungen und Mitarbeiter —, verarbeiten wir in Ihrem Auftrag (Art. 28 DSGVO). Verantwortlich
        für diese Daten ist Ihr Betrieb; wir verwenden sie ausschließlich, um LagerPro für Sie zu
        betreiben.
      </p>

      <h2>3. Welche Daten wir verarbeiten und warum</h2>
      <h3>Registrierung und Vertrag</h3>
      <p>
        Firma, Anschrift, Telefon, E-Mail, Name und Benutzername des Administrators, Passwort (nur als
        nicht umkehrbarer Hash), gewählter Tarif, Zustimmung zu AGB und Datenschutz mit Zeitpunkt.
        Zweck: Abschluss und Durchführung des Vertrags (Art. 6 Abs. 1 lit. b DSGVO).
      </p>
      <h3>Abrechnung und Lastschrift</h3>
      <p>
        Kontoinhaber, IBAN, BIC und Mandatsreferenz des SEPA-Lastschriftmandats, Rechnungen und
        Zahlungseingänge. Zweck: Abrechnung (Art. 6 Abs. 1 lit. b DSGVO) und gesetzliche
        Aufbewahrung unserer eigenen Rechnungen (Art. 6 Abs. 1 lit. c DSGVO i. V. m. § 147 AO,
        § 257 HGB).
      </p>
      <h3>Anmeldung und Sicherheit</h3>
      <p>
        Anmeldezeitpunkte, angemeldete Geräte und Sitzungen, Zwei-Faktor-Einstellungen, IP-Adresse bei
        sicherheitsrelevanten Vorgängen (z. B. Erteilung eines Lastschriftmandats). Zweck: Schutz Ihres
        Kontos und Nachvollziehbarkeit (Art. 6 Abs. 1 lit. b und f DSGVO).
      </p>
      <h3>E-Mails</h3>
      <p>
        Wir schicken Bestätigungen, Anmeldecodes, Rechnungen, Lastschrift-Ankündigungen und
        Hinweise zum Vertrag. Hinweise auf neue Funktionen nur, solange Sie sie nicht abbestellen —
        jede dieser Mails enthält einen Abmeldelink (Art. 6 Abs. 1 lit. f DSGVO, § 7 Abs. 3 UWG).
      </p>
      <h3>Kontaktformular</h3>
      <p>
        Anliegen, Name, E-Mail und Ihre Nachricht, bei Rückerstattungen die Rechnungsnummer,
        bei Kündigungen Firma und Kundenkennung. Zweck: Bearbeitung Ihres Anliegens
        (Art. 6 Abs. 1 lit. b und f DSGVO).
      </p>
      <h3>Server-Protokolle</h3>
      <p>
        Beim Aufruf von lagerpro.app speichert der Webserver IP-Adresse, Zeitpunkt, aufgerufene
        Adresse, Statuscode und Browserkennung. Zweck: Betrieb und Abwehr von Angriffen
        (Art. 6 Abs. 1 lit. f DSGVO). Die Protokolle werden nach 14 Tagen gelöscht.
      </p>

      <h2>4. Speicher im Browser, keine Werbe-Cookies</h2>
      <p>
        LagerPro speichert im lokalen Speicher Ihres Browsers bzw. der App nur, was für den Betrieb
        nötig ist: Ihre Anmeldung, die gewählte Sprache und Darstellung sowie offene Kassenbons.
        Das ist technisch erforderlich (§ 25 Abs. 2 Nr. 2 TDDDG). Wir setzen keine Werbe- oder
        Analyse-Cookies ein, binden keine Tracking-Dienste ein und laden keine Schriften oder Skripte
        von fremden Servern.
      </p>

      <h2>5. Empfänger und Dienstleister</h2>
      <ul>
        <li>
          <strong>Hetzner Online GmbH</strong>, Industriestr. 25, 91710 Gunzenhausen — Server und
          E-Mail-Versand. Die Server stehen in einem Rechenzentrum in Helsinki (Finnland, EU).
        </li>
        <li>
          <strong>OpenAI, L.L.C.</strong>, San Francisco, USA — nur wenn Sie den KI-Assistenten nutzen:
          die Datei bzw. Frage, die Sie dem Assistenten geben. Die Daten werden nur zur Beantwortung
          verarbeitet, nicht zum Trainieren von Modellen. Die Übermittlung in die USA erfolgt auf
          Grundlage der EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO).
        </li>
        <li>
          <strong>Enable Banking Oy</strong>, Espoo (Finnland) — nur wenn Sie Ihr Bankkonto verbinden:
          lizenzierter Kontoinformationsdienst, über den LagerPro Kontostand und Umsätze liest. Ihre
          Zugangsdaten geben Sie ausschließlich bei Ihrer Bank ein.
        </li>
        <li>
          <strong>Unser Kreditinstitut</strong> — zum Einzug der Lastschrift.
        </li>
      </ul>
      <p>Darüber hinaus geben wir Daten nur weiter, wenn ein Gesetz uns dazu verpflichtet.</p>

      <h2>6. Wie lange wir speichern</h2>
      <ul>
        <li>Kontodaten: für die Dauer des Vertrags.</li>
        <li>
          Nach Vertragsende können Sie 30 Tage lang eine Kopie Ihrer Daten anfordern; danach löschen
          wir die Daten Ihres Betriebs.
        </li>
        <li>Unsere eigenen Rechnungen an Sie: 8 Jahre (Buchungsbelege) bzw. 10 Jahre (Bücher).</li>
        <li>Server-Protokolle: 14 Tage.</li>
        <li>Kontaktanfragen: bis zur Erledigung, danach nur, soweit eine Aufbewahrungspflicht besteht.</li>
      </ul>
      <p>
        Wichtig: Die Aufbewahrungspflichten für die Unterlagen Ihres Betriebs (z. B. Ihre
        Ausgangsrechnungen) liegen bei Ihnen. Sichern Sie Ihre Daten vor Vertragsende.
      </p>

      <h2>7. Ihre Rechte</h2>
      <p>
        Sie haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17),
        Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch gegen
        Verarbeitungen auf Grundlage berechtigter Interessen (Art. 21 DSGVO). Eine Einwilligung können
        Sie jederzeit für die Zukunft widerrufen. Schreiben Sie uns dazu an
        <a href="mailto:info@quantory.de"> info@quantory.de</a> oder über das
        <a href="/kontakt"> Kontaktformular</a>.
      </p>
      <p>
        Sie können sich bei einer Datenschutz-Aufsichtsbehörde beschweren, für uns zuständig ist die
        Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen,
        Kavalleriestraße 2–4, 40213 Düsseldorf.
      </p>

      <h2>8. Pflicht zur Bereitstellung, keine automatisierten Entscheidungen</h2>
      <p>
        Ohne die Pflichtangaben bei der Registrierung können wir keinen Vertrag schließen. Wir treffen
        keine ausschließlich automatisierten Entscheidungen im Sinne von Art. 22 DSGVO.
      </p>
    </RechtsRahmen>
  );
}
